import { url } from '../c-mp/fun/url'
import { getServerUrl } from './getServerUrl'

export function getPersonImagesListUrl(personId: string) {
	return getServerUrl() + url`/list-images/${personId}`
}
